module.exports = __webpack_public_path__ + "static/img/sys_gauge.ebe8196e.png";